import { GenericObject, Locale, LocalizedString, copyFields } from '@synergy/models';

import { Product } from './product';

export class ProductSnapshot {
    public id?: number;
    public currency?: string;
    public isBestPrice!: boolean;
    public isNormArticle?: boolean;
    public name!: LocalizedString;
    public shortDescription?: LocalizedString;
    public longDescription?: LocalizedString;
    public price?: number;
    public specialPrice?: number;
    public product?: Product;
    public productNumber?: string;
    public quantity!: number;
    public orderUnit!: string;
    public tax?: number;
    public supplierAccountId?: number;
    public supplierAccountName?: string;
    public discount?: number;
    public contentQuantity?: number;
    public contentQuantityPrice?: number;
    public contentUnit?: string;

    public static fromPlainObject(object: GenericObject): ProductSnapshot {
        const productSnapshot = new ProductSnapshot();

        copyFields(object, productSnapshot);

        if (object['product']) {
            productSnapshot.product = Product.fromPlainObject(object['product']);
        }

        return productSnapshot;
    }

    public static fromProduct(product: Product, locale: Locale, currency?: string, taxRate?: string): ProductSnapshot {
        const snapshot = new ProductSnapshot();
        snapshot.name = product.name;
        snapshot.shortDescription = product.shortDescription;
        snapshot.longDescription = product.longDescription;
        snapshot.orderUnit = (product.orderUnitName && product.orderUnitName[locale]) || '';
        snapshot.isNormArticle = product.isNorm;
        snapshot.isBestPrice = product.isBestPrice;
        snapshot.productNumber = product.number;

        if (product.supplier) {
            snapshot.supplierAccountId = product.supplier.id;
            snapshot.supplierAccountName = product.supplier.name;
        }

        snapshot.quantity = 1;
        snapshot.orderUnit = product?.orderUnitName?.[locale] ?? '';
        snapshot.product = product;
        snapshot.tax = (product.tax && taxRate && product.tax[taxRate]) || 0;
        snapshot.discount = 0;

        if (currency) {
            snapshot.specialPrice = product.currentSpecialPrice && product.currentSpecialPrice[currency];
            snapshot.price = snapshot.specialPrice || product.mainPrice[currency] || 0;
        } else {
            snapshot.price = 0;
        }

        return snapshot;
    }

    public getDescription(): LocalizedString | undefined {
        const isNonEmpty = (localizedString: LocalizedString | undefined): boolean => {
            if (!localizedString) {
                return false;
            }

            return Object.values(localizedString).some(value => value?.trim().length > 0);
        };

        if (isNonEmpty(this.shortDescription)) {
            return this.shortDescription;
        }

        if (isNonEmpty(this.longDescription)) {
            return this.longDescription;
        }

        return undefined;
    }
}
